<template>
    <div class="bg">
        <div class="medialinks">
            <div class="title_content">
                <router-link :to="`/projects/${projectId}/chat`" class="route">
                    <IconComponent icon="arrows-left" class="icon"/>
                </router-link>
                <h2 class="title" v-if="project" v-html="project.name"></h2>
            </div>
            <div class="titles">
                <h3 class="media" :class="{ 'is-active': currentView === 'media' }" type="button"
                    @click.prevent="toggle('media')">
                    Ficheiros
                </h3>
                <h3 class="links" :class="{ 'is-active': currentView === 'links' }" type="button"
                    @click.prevent="toggle('links')">
                    Endereços
                </h3>
            </div>
            <div class="content">
                <ChatMedia class="links" v-if="currentView === 'media'" :projectId="projectId" />
                <ChatLinks class="media" v-if="currentView === 'links'" :projectId="projectId" />
            </div>
        </div>
    </div>
</template>

<script>

import IconComponent from '@/components/Icons.vue';
import ChatLinks from './Links.vue';
import ChatMedia from './Media.vue';

export default {
    name: 'MediaLinks',
    props: {
        projectId: { required: true }
    },
    components: {
        ChatLinks,
        ChatMedia,
        IconComponent
    },
    data() {
        return {
            currentView: null,
        }
    },
    methods: {
        toggle(view) {
            if (this.currentView === view) {
                this.currentView = null
            } else {
                this.currentView = view
            }
        },
    },
    computed: {
        project() {
            return this.$store.getters['projects/id'](this.projectId)
        },
    },

    watch: {
        projectId: {
            immediate: true,
            handler() {
                this.$store.dispatch('projects/getAll', this.projectId)
            },
        },
    },
    mounted() {},
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.bg{
    background-color: var(--bg-color-1);
    margin: 2rem;
    width: auto;
    border-radius: 10px;


    .medialinks {
        display: grid;
        text-align: center;
        grid-template-columns: auto;
        grid-template-rows: auto 1fr;
        grid-template-areas:
            'title'
            'titles'
            'content';

            .title_content{
                grid-area: title;
                text-transform: uppercase;
                display: flex;
                align-items: center;
                background: var(--bg-color-2);
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;

                .route {
                    padding: 0 2rem;
                }
                .title {}
            }


        .titles {
            grid-area: titles;
            display: flex;
            justify-content: space-around;
            background: var(--bg-color-2);
            
            .media,
            .links {
                cursor: pointer;
                margin: inherit;
                width: 100%;

                &:hover,
                &:active,
                &:focus {
                    color: var(--highlight-color);
                    border-bottom: 1px solid var(--highlight-color);
                }

                &.is-active {
                    color: var(--highlight-color);
                    border-bottom: 1px solid var(--highlight-color);
                }
            }
        }

        .content {
            grid-area: content;
        }
    }
}

.icon {
    width: 10px;
    height: 10px;
    fill: var(--text-color);
}
</style>
